import { useTranslation } from 'react-i18next';
import { TextV2 } from '@insights-ltd/design-library/components';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const StyledSpan = styled(TextV2)(({ theme }) => ({
  paddingLeft: theme.spacing(0.5),
}));

type SectionProps = {
  title: string;
  value: number;
  testId: string;
};
const Section = ({ title, value, testId }: SectionProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={(theme) => ({ padding: theme.spacing(2), alignItems: 'left' })}>
      <TextV2 component="h2" variant="h4">
        {t(title)}
      </TextV2>
      <TextV2 component="span" variant="h2" data-testid={testId}>
        {value}
      </TextV2>
      <StyledSpan component="span" variant="bodyBold" color="textSecondary">
        {t('ui.event-management.events.unit-management.value.units')}
      </StyledSpan>
    </Box>
  );
};
export default Section;
